import { FunctionComponent } from 'react';
import { Role } from '@monorepo/types';
import { useStore } from '../helpers/use-store';

const withImpersonation = <P extends object>(
  WrappedComponent: FunctionComponent<P>,
  allowedRoles: Role[],
): FunctionComponent<P> => {
  return (props: P) => {
    const {
      dataStore: { userStore },
    } = useStore();

    const hasImpersonationAccess = userStore.hasImpersonationAccess({
      roles: allowedRoles,
    });

    if (!hasImpersonationAccess) {
      return null;
    }

    return <WrappedComponent {...props} />;
  };
};

export default withImpersonation;
